var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.918 33.582-.32.342.32.342 2.094 2.235.365.389.365-.39 16.011-17.079.32-.342-.32-.342-16.011-17.08-.365-.388-.365.389-2.094 2.234-.32.342.32.342L32.563 17H.5v4.16h32.063L20.918 33.582Z"
  })));
};
export default SvgArrowRight;